"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var TagInput = {
  styles: function styles(theme) {
    return {
      label: {
        color: theme.colors.baseContrast070,
        textTransform: "uppercase",
        fontSize: theme.typography.fontSize,
        fontWeight: 600,
        lineHeight: "20px",
        paddingBottom: theme.spacing.base / 2
      },
      description: {
        color: theme.colors.baseContrast070,
        textTransform: "none",
        fontSize: theme.typography.fontSize,
        lineHeight: "20px"
      },
      container: {
        background: theme.colors.themeBase,
        fontSize: theme.typography.fontSize + 1,
        color: theme.colors.baseContrast070,
        borderColor: theme.colors.baseContrast040,
        borderRadius: 8,
        borderWidth: 1,
        "&:has(input:focus)": {
          borderColor: theme.colors.primary,
          boxShadow: "0 0 0 4px ".concat(theme.colors.primary, "33")
        },
        "&:has(input:hover)": {
          borderColor: theme.colors.primary
        },
        "&:has(div:hover)": {
          borderColor: theme.colors.primary
        }
      },
      inputContainer: {
        fontSize: theme.typography.fontSize + 1
      },
      input: {
        "&::placeholder": {
          color: theme.colors.baseContrast050
        }
      },
      tag: {
        "& > span": {
          paddingTop: 0
        }
      }
    };
  }
};
var _default = exports.default = TagInput;